{
  "version": 1,
  "asset_id": "f73b3ff3-def1-42c6-94e7-cd9b6f0c4e5a",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/f73b3ff3-def1-42c6-94e7-cd9b6f0c4e5a/Give.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/f73b3ff3-def1-42c6-94e7-cd9b6f0c4e5a/Give.png",
  "original_filename": "Give.png",
  "size": 653601,
  "content_type": "image/png",
  "created_at": "2026-08-18T18:27:13Z"
}
